import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { COUNTRY_WITHOUT_TITLEDETAIL } from '@/constants/web-locales.constant';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { computed, ref } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleRemovalBanner',
  setup(__props) {

const { webLocale } = useLanguageStore();

const isClosed = ref(false);
const showBanner = computed(() => !isClosed.value && COUNTRY_WITHOUT_TITLEDETAIL.includes(webLocale.value));

const appLink = {
	ios: 'https://apps.apple.com/app/apple-store/id979227482',
	android: 'https://play.google.com/store/apps/details?id=com.justwatch.justwatch',
};

const applicationUrl = computed(() => {
	const userAgent = window.navigator.userAgent;

	if (!userAgent) return '';

	if (userAgent.match(/Windows|Linux/i) || userAgent.match(/android/i)) return appLink.android;
	if (userAgent.match(/Macintosh/i) || userAgent.match(/(iPhone|iPad)/)) return appLink.ios;

	return '';
});

function close() {
	isClosed.value = true;
	TrackingHelper.trackEvent('titleremovalbanner', {
		action: 'hide_click',
	});
}

function clickout() {
	TrackingHelper.trackEvent('titleremovalbanner', { action: 'clickout' });
}

return { __sfc: true,webLocale, isClosed, showBanner, appLink, applicationUrl, close, clickout, BasicButton }
}

})